import { forwardRef as S, createElement as N } from "react";
import { createRoot as z } from "react-dom/client";
import { jsx as u, jsxs as I } from "react/jsx-runtime";
import { c as w } from "./tw-cn-mXgPecoF.mjs";
import { T as _ } from "./text-button-CnKFU0fa.mjs";
import { c as y } from "./variance-DhhqoHkK.mjs";
const B = y(["fixed w-full pointer-events-none"], {
  variants: {
    active: {
      true: "",
      false: ""
    },
    position: {
      bottom: "mx-auto left-1/2 bottom-0",
      top: "mx-auto left-1/2 top-20",
      center: "mx-auto left-1/2 top-1/2"
    }
  },
  compoundVariants: [
    // bottom과 top은 같은 애니메이션 사용
    {
      active: !0,
      position: ["bottom", "top"],
      className: "animate-toastFadeIn"
    },
    {
      active: !1,
      position: ["bottom", "top"],
      className: "animate-toastFadeOut"
    },
    // center는 별도의 opacity 애니메이션 사용
    {
      active: !0,
      position: "center",
      className: "animate-toastCenterFadeIn"
    },
    {
      active: !1,
      position: "center",
      className: "animate-toastCenterFadeOut"
    }
  ]
}), k = y(["inline-flex", "bg-fill-neutral-main", "pointer-events-auto"], {
  variants: {
    size: {
      medium: "max-w-[320px] pc:max-w-[343px] px-20 mb-20",
      large: "min-w-[320px] max-w-[480px] px-24 mb-24"
    },
    radius: {
      "rounded-4": "rounded-4",
      "rounded-6": "rounded-6",
      "rounded-8": "rounded-8"
    },
    position: {
      bottom: "-translate-x-1/2",
      top: "-translate-x-1/2",
      center: "-translate-x-1/2 -translate-y-1/2"
    },
    hasTextButton: {
      true: "items-center justify-between",
      false: ""
    }
  },
  compoundVariants: [
    {
      size: "medium",
      hasTextButton: !0,
      className: "gap-20 w-[calc(100%-32px)] max-w-none pc:w-[343px]"
    },
    {
      size: "large",
      hasTextButton: !0,
      className: "gap-24 max-w-[580px]"
    }
  ],
  defaultVariants: {
    size: "medium",
    hasTextButton: !1
  }
}), E = y("", {
  variants: {
    size: {
      medium: "py-12",
      large: "py-16"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), $ = y(
  ["text-static-white whitespace-pre-line", "break-words line-clamp-2", "cursor-default select-none"],
  {
    variants: {
      size: {
        medium: "typography-body-14-regular",
        large: "typography-subtitle-16-regular-multiline"
      }
    },
    defaultVariants: {
      size: "medium"
    }
  }
), b = 9999, A = {
  medium: "small",
  large: "large"
}, T = S(
  ({
    active: a,
    children: e,
    size: t = "medium",
    radius: r = "rounded-8",
    bottomOffset: o = 0,
    position: i = "bottom",
    textButton: n,
    onAnimationEnd: c = () => {
    },
    // 기본값 9999로 설정
    zIndex: f = b,
    rootContainerClass: x = ""
  }, l) => {
    const v = B({ active: a, position: i }), h = k({ size: t, radius: r, position: i, hasTextButton: !!n }), m = E({ size: t }), d = $({ size: t }), C = typeof o == "number" ? `${o}px` : o, g = A[t];
    return /* @__PURE__ */ u("div", { className: x, children: /* @__PURE__ */ u(
      "div",
      {
        className: v,
        onAnimationEnd: c,
        ref: l,
        style: { paddingBottom: `calc(var(--safe-area-bottom) + ${C})`, zIndex: f },
        children: /* @__PURE__ */ I("div", { className: w([h, r]), children: [
          /* @__PURE__ */ u("div", { className: m, children: /* @__PURE__ */ u("span", { className: d, children: e }) }),
          n ? /* @__PURE__ */ u(
            _,
            {
              className: w("shrink-0", t === "medium" && "my-8"),
              icon: n.icon,
              mobileSize: g,
              onClick: n.onClick,
              pcSize: g,
              theme: n.icon ? "default" : "underline",
              transparent: !0,
              weight: t === "large" ? "bold" : "regular",
              children: n.text
            }
          ) : null
        ] })
      }
    ) });
  }
);
T.displayName = "NDS.Toast";
const V = "toast-container", s = [];
let p;
const q = ({
  id: a,
  className: e = "",
  duration: t = 3e3,
  clearOtherToast: r,
  zIndex: o = b,
  onAnimationEnd: i,
  ...n
}) => {
  const c = a || `toast_${Date.now()}`;
  let f;
  const x = F(c, e, o), l = z(x), v = (d) => {
    clearTimeout(f), l.unmount(), x.remove(), d || i == null || i(), O(m);
  }, h = () => {
    l.render(/* @__PURE__ */ N(T, { ...n, active: !0, key: c })), f = window.setTimeout(() => {
      l.render(/* @__PURE__ */ N(T, { ...n, active: !1, key: c, onAnimationEnd: v }));
    }, t);
  }, m = {
    toastKey: c,
    add: h,
    remove: v
  };
  return r && s.forEach(({ remove: d }) => {
    d();
  }), s.push(m), s.length === 1 && (p = s[0], h()), m;
};
function F(a, e, t) {
  const r = document.querySelector("body"), o = document.createElement("div");
  return o.className = `${V} ${a} ${e}`, o.style.position = "relative", o.style.zIndex = t.toString(), r.appendChild(o);
}
function O(a) {
  const e = s.findIndex((t) => t === a);
  if (s.splice(e, 1), s.length > 0) {
    const t = s[0];
    p = t, t.add();
  }
}
function K(a) {
  for (; s.length; ) {
    const e = s.shift();
    e == null || e.remove(a);
  }
  p == null || p.remove(a);
}
export {
  b as M,
  T,
  K as c,
  q as s
};
